import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import useAuthData from "../../hook/useAppData";
import { IconX } from "../../icons";
import { convertDate } from "../../libs/dateUtils";
import { orderBy } from "../../libs/orderBy";
import { validationWorkTime } from "../../module/TimeSheet/lib";
import IconButton from "../IconButton";
import Spinner from "../Spinner";
import { IDetailsTimesheetPoints, IReqDetailsTimesheet } from "./models";
import { getDetailsTimesheetPoints, getTimePointDetailsDownload } from "./services";
import { CSVLink } from "react-csv";
import { toastError } from "../Toast";
import "./index.scss";

interface ModalDetails {
  dateFrom?: string;
  dateTo?: string;
  period?: string;
  value: IValueModal;
  exit: any;
}

interface IValueModal {
  userId: number;
  userName: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export function ModalDetailsTimesheet({ dateFrom, dateTo, period, value, exit }: ModalDetails) {
  const { token } = useAuthData();
  const [needSpinner, setNeedSpinner] = useState(true);
  const [dateGridList, setDateGridList] = useState<IReqDetailsTimesheet>();
  const [csv, setCsv] = useState("");
  const [year, month] = period ? period?.split("-") : ["", ""];
  const lastDay = new Date(+year, +month, 0).getDate();
  let periodFrom = period + "-01";
  let periodTo = period + `-${lastDay}`;

  const datePeriodFormated = new Date(+year, +month - 1)?.toLocaleDateString("pt-BR", {
    year: "numeric",
    month: "long",
  });

  useEffect(() => {
    getPointsRange();
    getGreaterPossible();
    handleExportCSV();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getPointsRange() {
    setNeedSpinner(true);
    let query = `?userId=${value?.userId}&dateFrom=${dateFrom || periodFrom}&dateTo=${dateTo || periodTo}`;
    const data: IReqDetailsTimesheet = await getDetailsTimesheetPoints(token, query);
    const pointsOrderByDate = orderBy(data?.points, "date", "desc");
    const newDataOrderPointsByDate: IReqDetailsTimesheet = {
      ...data,
      points: pointsOrderByDate,
    };
    if (!newDataOrderPointsByDate?.points?.length) return setNeedSpinner(false);
    setDateGridList(newDataOrderPointsByDate);
    setNeedSpinner(false);
  }

  function getGreaterPossible() {
    const pointsLength = dateGridList?.points?.map((point) => point?.timePoints?.length);
    const greaterBetweenPoints = pointsLength?.reduce((acc, item) => Math.max(acc, item));
    return greaterBetweenPoints;
  }

  async function handleExportCSV() {
    const data = await getTimePointDetailsDownload(value?.userId, dateFrom || periodFrom, dateTo || periodTo, token);
    try {
      if (!data?.length) return;
      setCsv(data);
    } catch (error) {
      console.error(error);
      toastError("Erro!");
    }
  }

  return (
    <>
      <Toaster />
      <div className="modalContainer modalTimesheetDetails">
        <div className="modalTitle">
          <h1>
            Detalhe Time Sheet {period ? `de ${datePeriodFormated}` : dateFrom && dateTo ? `${convertDate(dateFrom)} à ${convertDate(dateTo)}` : ""}
          </h1>
          <IconButton className="iconX" icon={IconX} onClick={() => exit()} />
        </div>
        <Spinner className="spinner" status={needSpinner}>
          <div className="modalHeader">
            <span>Profissional: {value?.userName}</span>
            <CSVLink data={csv} filename={`${value?.userName} - Time Sheet - ${period}.csv`} target="_blank" className="csvLink">
              <button className="Link email btn bg-primary">Download CSV</button>
            </CSVLink>
          </div>
          <div className="modalBody">
            <div className="timesheetTableContainer timesheetTableModal">
              <table className="timesheetTable">
                {dateGridList?.points?.length ? (
                  <>
                    <thead>
                      <tr>
                        {dateGridList?.points[0]?.contractType === "PJ" ? (
                          <>
                            <th className="thLeft">Data</th>
                            <th className="thLeft">Dia</th>
                            <th className="thCenter">Registros</th>
                          </>
                        ) : (
                          <>
                            <th className="thLeft">Data</th>
                            <th className="thLeft">Dia</th>
                            {Array.from({ length: getGreaterPossible() }).map((_) => {
                              return (
                                <>
                                  <th className="thCenter">Entrada</th>
                                  <th className="thCenter">Saída</th>
                                </>
                              );
                            })}
                            <th className="thCenter">Extra 75%</th>
                            <th className="thCenter">Extra 100%</th>
                            <th className="thCenter">Noturno</th>
                            <th className="thCenter">Total</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {dateGridList?.points[0]?.contractType === "CLT" ? (
                        <TBodyTimeCLT list={dateGridList.points} maior={getGreaterPossible()} />
                      ) : (
                        <TBodyTimePJ list={dateGridList.points} maior={getGreaterPossible()} />
                      )}
                    </tbody>
                    {dateGridList?.points[0]?.contractType === "CLT" ? (
                      <tr className="rowGreyDark">
                        <td colSpan={getGreaterPossible() * 2 + 1}></td>
                        <td>
                          <h1 className="font-roboto">total:</h1>
                        </td>
                        <td>{dateGridList.total?.threeQuartersHours}</td>
                        <td>{dateGridList.total?.fullHours}</td>
                        <td>{dateGridList.total?.nightShiftAdditional}</td>
                        <td className="status">
                          <span>Total de horas: </span>
                          <span>{dateGridList.total?.total}</span>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <div className="nothing-list">
                    <h1>Não há registros para a busca realizada.</h1>
                  </div>
                )}
              </table>
            </div>
          </div>
        </Spinner>
      </div>
    </>
  );
}

function TBodyTimePJ({ list }: { list; maior: number }) {
  return list?.map((row: IDetailsTimesheetPoints, index: any) => {
    const { id, date, total } = row;
    const validation = validationWorkTime(total);
    const [year, month, day] = String(date)?.split("-");
    const dateLocale = new Date(+year, +month - 1, +day)?.toLocaleDateString();
    const dayOfWeek = new Date(+year, +month - 1, +day)?.toLocaleDateString("pt-br", { weekday: "short" });
    return (
      <>
        <tr className={`${index % 2 !== 0 && "rowGrey"}`} id={String(id)} key={index}>
          <td>{dateLocale}</td>
          <td>{dayOfWeek}</td>
          <td className="status">
            <span>Total de horas: </span>
            <span className={`${validation}`}>{total}</span>
          </td>
        </tr>
      </>
    );
  });
}

function TBodyTimeCLT({ list, maior }: { list; maior: number }) {
  return list?.map((row: IDetailsTimesheetPoints, index: any) => {
    const { id, date, total, timePoints, threeQuartersHours, fullHours, nightShiftAdditional } = row;
    const validation = validationWorkTime(total);
    const [year, month, day] = String(date)?.split("-");
    const dateLocale = new Date(+year, +month - 1, +day)?.toLocaleDateString();
    const dayOfWeek = new Date(+year, +month - 1, +day)?.toLocaleDateString("pt-br", { weekday: "short" });
    return (
      <>
        <tr className={`${index % 2 === 0 && "rowGrey"}`} id={String(id)} key={index}>
          <td>{dateLocale}</td>
          <td>{dayOfWeek}</td>
          {Array.from({ length: maior })?.map((_, index) => {
            return (
              <>
                <td>{timePoints[index]?.inputTime || "--:--"}</td>
                <td>{timePoints[index]?.outTime || "--:--"}</td>
              </>
            );
          })}
          <td>{threeQuartersHours || "--:--"}</td>
          <td>{fullHours || "--:--"}</td>
          <td>{nightShiftAdditional || "--:--"}</td>
          <td className="status">
            <span>Total de horas: </span>
            <span className={`${validation}`}>{total}</span>
          </td>
        </tr>
      </>
    );
  });
}
